import { render } from "./StatsView.vue?vue&type=template&id=5968481a&scoped=true"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"

import "./StatsView.vue?vue&type=style&index=0&id=5968481a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5968481a"]])

export default __exports__